const reportWebVitals = onPerfEntry => { if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(_ref => { let { getCLS, getFID, getFCP, getLCP, getTTFB } = _ref; getCLS(onPerfEntry); getFID(onPerfEntry); getFCP(onPerfEntry); getLCP(onPerfEntry); getTTFB(onPerfEntry); });
} };
export default reportWebVitals;
